import api from './api';

export const getLicenseStatus = () => api.get('/license/status');
export const retryLicense = () => api.post('/license/retry');
